// extracted by mini-css-extract-plugin
export default {"title":"appTitleWithLine_title__jSJBp","hr":"appTitleWithLine_hr__zJD0t","subTitleWrapper":"appTitleWithLine_subTitleWrapper__aI8TX","subTitle":"appTitleWithLine_subTitle__cIvET"};